// Angular
import { NgModule } from '@angular/core';
import { environment } from './../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http'
import { FormsModule } from '@angular/forms';
// Angular

// PrimeNG
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ButtonModule } from 'primeng/button';
import { ConfirmationService } from 'primeng/api';
import { AccordionModule } from 'primeng/accordion';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule, Dialog } from 'primeng/dialog';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { CheckboxModule } from 'primeng/checkbox';
import { CalendarModule, Calendar } from 'primeng/calendar';
// PrimeNG

// Outros Pacotes
import { RatingModule } from 'ng-starrating';
// Outros Pacotes

// Maps
import { AgmCoreModule } from '@agm/core';
//Maps

// Components
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { MapsComponent } from './maps/maps.component';
import { LoginComponent } from './login/login.component';
import { CompraComponent } from './compra/compra.component';
// Components





@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MapsComponent,
    LoginComponent,
    CompraComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    AngularFirestoreModule,
    InputTextModule,
    ButtonModule,
    AccordionModule,
    BrowserAnimationsModule,
    HttpClientModule,
    OverlayPanelModule,
    FormsModule,
    DialogModule,
    ConfirmDialogModule,
    RatingModule,
    ScrollPanelModule,
    CheckboxModule,
    CalendarModule,
    AngularFireModule.initializeApp(environment.firebase),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAbVMD_snr6tRhLlYFtoUMAyMdxOuTj5zw'
    })
  ],
  providers: [ConfirmationService],
  bootstrap: [AppComponent]
})
export class AppModule { }
